import { ref, onMounted, watch, nextTick } from 'vue';
import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-426fa0a3"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "chatlist_container"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "shade"
}, null, -1));
const _hoisted_3 = ["innerHTML"];
const _hoisted_4 = {
  key: 1,
  class: "item item_loading item_left"
};
import bus from '@/utils/mitt.js';
import LottieView from '@/components/lottieView.vue';
// import lottieJson from './loading.json'
import lottieJson from '../../../../public/animationData/chat/loading.json';
import userHooks from '@/hooks/userHooks';
import { saveChatMessage, getChatMessage } from '@/api/chat';
import roleHooks from '@/hooks/roleV2Hooks';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props, {
    expose
  }) {
    const {
      macId,
      getMacId,
      getMessageTotalInfo,
      uuid
    } = userHooks();
    const {
      curSelectRoleInfo
    } = roleHooks();
    const chatList = ref([]);
    const chatref = ref(null);
    onMounted(() => {
      bus.on('chatmessage', dellChat);
    });
    watch(curSelectRoleInfo, () => {
      chatList.value = [];
    });
    const dellChat = data => {
      updateChatList(data);
      scrollBottom();
    };
    const saveChat = data => {
      getMacId(async macId => {
        if (data.type == 'right' || data.type == 'left') {
          const res = await saveChatMessage({
            macId: macId,
            content: data.content,
            roleId: curSelectRoleInfo.value.id,
            type: data.type == 'right' ? 1 : 2,
            session: uuid.value
          });
        }
      });
    };
    const stream = ref();
    const updateChatList = data => {
      if (data.type == 'left') {
        if (data.done == -1) {
          chatList.value.pop();
          return;
        }
        chatList.value[chatList.value.length - 1] = {
          ...data
          // content: data.content.replace(/\n/g,"<br/>")
        };

        saveChat({
          ...data
        });
      } else {
        chatList.value.push(data);
        chatList.value.push({
          type: 'left'
        });
        saveChat(data);
      }
    };
    const getChatMessageList = () => {
      return;
      getMacId(async macId => {
        const res = await getChatMessage({
          macId: macId,
          roleId: curSelectRoleInfo.value.id
        });
        chatList.value = res.map(vo => {
          return {
            ...vo,
            type: vo.type == 1 ? 'right' : 'left'
          };
        });
        scrollBottom();
      });
    };
    watch(curSelectRoleInfo, newval => {
      if (newval) {
        getChatMessageList();
      }
    });
    expose({
      getChatMessageList
    });
    watch(chatList.value, () => {
      scrollBottom();
    }, {
      deep: true
    });
    const scrollBottom = () => {
      nextTick(() => {
        chatref.value.scrollTop = chatref.value.scrollHeight;
      });
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", {
        class: _normalizeClass(["scrolldiv", {
          scrolldivtype3: _ctx.$route.query.type == 'show'
        }]),
        ref_key: "chatref",
        ref: chatref
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(chatList), (vo, index) => {
        return _openBlock(), _createElementBlock(_Fragment, {
          key: index
        }, [vo.content ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["item item_text item_left", vo.type == 'left' ? 'item_left' : 'item_right']),
          innerHTML: vo.content
        }, null, 10, _hoisted_3)) : _createCommentVNode("", true), !vo.content ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createVNode(LottieView, {
          id: 'chat' + index,
          class: "chat_loading",
          autoplay: true,
          loop: true,
          jsonData: _unref(lottieJson),
          assetsPath: "/animationData/chat/"
        }, null, 8, ["id", "jsonData"])])) : _createCommentVNode("", true)], 64);
      }), 128))], 2)]);
    };
  }
});